import Service from "../../../Services/index";

const TransportType = {
    namespaced: true,
    state: {
        transportTypeList: [],
        transportSelect : [],
        transport_type_all : []
    },
    mutations: {
        SET_TRANSPORT_TYPE_LIST: (state, data) => {
            state.transportTypeList = data.map(transport=>({
                id : transport.id,
                name : transport.name,
                transport_id : transport.id,
                fee : transport.fee
            }));
        },
        SET_TRANSPORT_TYPE_ALL :(state,data)=>{
            state.transport_type_all = data;
        }
    },
    actions: {
        setTransportTypes({ commit }) {
            return Service.transportType.getTransportType().then(data => {
                commit("SET_TRANSPORT_TYPE_LIST", data);
            });
        },
        transportTypeAll({commit}){
            return Service.transportType.getTransportType().then(data => {
                commit("SET_TRANSPORT_TYPE_ALL", data);
            });
        }
    }
};

export default TransportType;
